module.exports = __webpack_public_path__ + "static/media/illustration-auto.7825a949.svg";